"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGoToLeadmailer(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.76 8l4.681 3.103L20.231 8H10.76zm10.74.37V17h-12l.002-.781h-1l-.002.778A1 1 0 009.5 18h12a1 1 0 001-1V8a1 1 0 00-1-1H9.522a1 1 0 00-1 .998L8.52 9.09h1l.001-.711 5.64 3.738.274.181.275-.178 5.79-3.75z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M1.502 10.127h7v1h-7zm2 2h4v1h-4v-1zm2 2h3v1h-3z"
  }));
}

var MemoSvgGoToLeadmailer = /*#__PURE__*/React.memo(SvgGoToLeadmailer);
var _default = MemoSvgGoToLeadmailer;
exports["default"] = _default;